import React, { useState } from "react";

export default function Gallery({ images, startIndex, onClose }) {
  const [currentImage, setCurrentImage] = useState(startIndex || 0);
  const [scale, setScale] = useState(1);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
    setScale(1);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
    setScale(1);
  };

  const handleWheelZoom = (e) => {
    e.preventDefault();
    let newScale = scale + e.deltaY * -0.0015;
    newScale = Math.min(Math.max(1, newScale), 5);
    setScale(newScale);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.95)",
        zIndex: 100000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        animation: "fadeIn 0.3s",
      }}
    >
      {/* Main image */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          width: "100%",
          position: "relative",
        }}
      >
        <img
          src={images[currentImage].imageName}
          alt=""
          style={{
            maxHeight: "98%",
            maxWidth: "98%",
            transform: `scale(${scale})`,
            transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
            cursor: "grab",
          }}
          onWheel={handleWheelZoom}
          draggable={false}
        />

        {/* Previous */}
        <button onClick={prevImage} className="gallery-prev">
          ‹
        </button>

        {/* Next */}
        <button onClick={nextImage} className="gallery-next">
          ›
        </button>
      </div>

      {/* Thumbnails */}
      <div
        style={{
          display: "flex",
          gap: "0.5em",
          overflowX: "auto",
          padding: "0.5em",
          maxWidth: "90%",
        }}
      >
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img.imageName}
            alt=""
            style={{
              width: "4em",
              height: "4em",
              objectFit: "cover",
              cursor: "pointer",
              border:
                idx === currentImage
                  ? "2px solid #fff"
                  : "2px solid transparent",
              transition: "all 0.3s",
              transform: idx === currentImage ? "scale(1.1)" : "scale(1)",
            }}
            onClick={() => setCurrentImage(idx)}
          />
        ))}
      </div>

      {/* Close button */}
      <button onClick={onClose} className="gallary-button">
        ×
      </button>
    </div>
  );
}
